import React, { useState, useEffect } from 'react';
import './InterviewSchedule.css';

const ProcessDetail = ({ applicant, notes, handleAddNote, newNote, setNewNote, handleMoveNextClicked }) => {

    const [showAddNote, setShowAddNote] = useState(false);

    const stageProgress = [
        { name: 'In-Review', status: 'submitted' },
        { name: 'test', status: 'test' },
        { name: 'Interview', status: 'interview' },
        { name: 'Decision', status: 'decision' }
    ]
    
    const getStageClass = (status, currentStage) => {
        if(status === "submitted") {
          if (currentStage === "submitted") {
            return 'stage-current';
          }
          return 'stage-pending';
        } else if(status === "test") {
          if (currentStage === "submitted") {
            return 'stage-completed';
          } else if (currentStage === "test") {
            return 'stage-current';
          }
          return 'stage-pending';
        } else if(status === "interview") {
          if (currentStage === "submitted") {
            return 'stage-completed';
          } else if (currentStage === "test") {
            return 'stage-completed';
          }  else if (currentStage === "interview") {
            return 'stage-current';
          }
          return 'stage-pending';
        } else if(status === "decision") {
          if (currentStage === "decision") {
            return 'stage-current';
          }
          return 'stage-completed';
        }
    }

    const getLevel = (status, currentStage) => {
        if(status === "submitted") {
          if (currentStage === "submitted") {
            return '';
          }
          return 'completed';
        } else if(status === "test") {
          if (currentStage === "submitted") {
            return 'completed';
          } else if (currentStage === "test") {
            return 'stage-current';
          }
          return 'stage-pending';
        } else if(status === "interview") {
          if (currentStage === "submitted") {
            return 'completed';
          } else if (currentStage === "test") {
            return 'completed';
          }  else if (currentStage === "interview") {
            return 'current';
          }
          return 'stage-pending';
        } else if(status === "decision") {
          if (currentStage === "decision") {
            return 'current';
          }
          return 'completed';
        }
    }

    return (
        <div className="hiring-progress-container">
            <div className="progress-content">
                <div className="progress-header">
                    <h2>Current Stage</h2>
                    {/* <button className="give-rating-btn">
                    <span className="dropdown-icon">▼</span>
                    Give Rating
                    </button> */}
                </div>
    
            <div className="stage-progress">
                <div className="progress-steps">
                {stageProgress.map((stage, index) => (
                    <div key={index} className={`progress-step ${getStageClass(stage.status, applicant.stages)}`}>
                    <div className="step-content">
                        {stage.name}
                    </div>
                    {index < stageProgress.length - 1 && (
                        <div className={`step-connector ${getLevel(stage.status, applicant.stages) === 'completed' ? 'completed' : ''}`}></div>
                    )}
                    </div>
                ))}
                </div>
            </div>
    
            <div className="stage-info">
                <h3>Stage Info</h3>
                <div className="info-grid">
                { applicant.process_update.length > 0 && (
                    <>
                    <div className="info-section">
                        <h4>Title</h4>
                        <p>{applicant.process_update[0].title}</p>
                    </div>
                    <div className="info-section">
                        <h4>Interview Status</h4>
                        <span className="status-badge on-progress">{applicant.process_update[0].stages}</span>
                    </div>
                    <div className="info-section">
                        <h4>Details</h4>
                        <p className="location-text">{applicant.process_update[0].details}</p>
                    </div>
                    <div className="info-section">
                        <h4>Deadline</h4>
                        <p className="location-text">{applicant.process_update[0].deadline_date}</p>
                    </div>
                    <div className="info-section">
                        <h4>Assigned to</h4>
                        <div className="assigned-avatars">
                            <div key={applicant.process_update[0].process_id} className="assigned-avatar">
                            <img src={`${process.env.REACT_APP_API_URL}/profile/get-pic/${encodeURIComponent(applicant.process_update[0].posted_by_user_id)}`}
                            alt={applicant.process_update[0].email} />
                            <p className="location-text">{applicant.process_update[0].email}</p>
                            </div>
                    </div>
                </div>
                    </>
                )}

                </div>
            </div>
    
            <div className="action-section">
                <button 
                    disabled={applicant.status !== "active" && applicant.status !== "pending"}
                    onClick={() => { handleMoveNextClicked(true) } } 
                    className="move-next-btn">Move To Next Step</button>
            </div>
    
            <div className="notes-section">
                <div className="notes-header">
                <h3>Notes</h3>
                <button 
                    className="add-notes-btn"
                    onClick={() => setShowAddNote(!showAddNote)}
                >
                    <span className="plus-icon">+</span>
                    Add Notes
                </button>
                </div>
    
                {showAddNote && (
                <div className="add-note-form">
                    <textarea
                    value={newNote}
                    onChange={(e) => setNewNote(e.target.value)}
                    placeholder="Write your note here..."
                    className="note-textarea"
                    />
                    <div className="note-actions">
                    <button onClick={handleAddNote} className="save-note-btn">Save Note</button>
                    <button onClick={() => setShowAddNote(false)} className="cancel-note-btn">Cancel</button>
                    </div>
                </div>
                )}
    
                <div className="notes-list">
                    {notes.map(note => (
                        <div key={note.application_notes_id} className="note-item">
                        <div className="note-header">
                            <div className="note-author">
                            <img src={note.avatar} alt={note.user_email} className="author-avatar" />
                            <span className="author-name">{note.user_names}</span>
                            </div>
                            <span className="note-timestamp">
                                  {new Date(note.created_at).toLocaleDateString('en-US', {
                                      day: 'numeric',
                                      month: 'short',
                                      year: 'numeric'
                                    })}
                            </span>
                        </div>
                        <p className="note-content">{note.notes}</p>
                        {/* {note.replies > 0 && (
                            <button className="replies-btn">{note.replies} Replies</button>
                        )} */}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>    
    );
};
export default ProcessDetail;